import ApprentiDateDebut from '@/generated/controls/apprenti/ApprentiDateDebut.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ApprentiDateDebut
})
